import ContentLanding from "./content-landing";

export default ContentLanding;
